import { EnvMicroAudit } from "lib-klab-core";

export const envAuditLocal: EnvMicroAudit = {
  host: "",
  apiBasePath: "/ms-audit",
  enabled: true,
};

export const envAuditDev: EnvMicroAudit = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-audit",
  enabled: true,
};

export const envAuditProd: EnvMicroAudit = {
  host: "",
  apiBasePath: "/ms-audit",
  enabled: false,
};
